function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.33325C9.10457 1.33325 10 2.27581 10 3.43852V8.3508C10 9.5135 9.10457 10.4561 8 10.4561C6.89543 10.4561 6 9.5135 6 8.3508V3.43852C6 2.27581 6.89543 1.33325 8 1.33325ZM11.5 5.89466C11.2239 5.89466 11 6.1303 11 6.42097V8.3508C11 10.0949 9.65685 11.5087 8 11.5087C6.34315 11.5087 5 10.0949 5 8.3508V6.42097C5 6.1303 4.77614 5.89466 4.5 5.89466C4.22386 5.89466 4 6.1303 4 6.42097V8.3508C4.00099 10.4719 5.50074 12.2611 7.5 12.5262V13.614H6.16667C5.89052 13.614 5.66667 13.8496 5.66667 14.1403C5.66667 14.4309 5.89052 14.6666 6.16667 14.6666H9.83333C10.1095 14.6666 10.3333 14.4309 10.3333 14.1403C10.3333 13.8496 10.1095 13.614 9.83333 13.614H8.5V12.5262C10.4993 12.2611 11.999 10.4719 12 8.3508V6.42097C12 6.1303 11.7761 5.89466 11.5 5.89466Z"
});

var SvgMice = function SvgMice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#F14D38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mice.094c3b1c.svg";
export { ForwardRef as ReactComponent };